export default __webpack_public_path__ + "static/media/wellness-assistance.dc179de0.png";